<template>
  <div class="day-legend" v-bind="$attrs" v-on="$listeners">
    <img src="@/assets/IC_Ausencia_Injustificada.svg" /><span v-if="withTitle">{{
      $t("pages.permission.absences.unjustified")
    }}</span>
  </div>
</template>

<script>
export default {
  props: {
    withTitle: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style></style>
